
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class BioHazardEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (300 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.fillStyle = pc.color;
        ctx.lineWidth = 2 * scale;

        const drawSymbol = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.rotate(curTime * 0.2);
             ctx.globalAlpha *= 0.3;
             
             // Outer ring
             ctx.beginPath();
             ctx.arc(0, 0, s/2, 0, Math.PI * 2);
             ctx.stroke();
             
             // Hazard triangles
             for (let i = 0; i < 3; i++) {
                 ctx.rotate(Math.PI * 2 / 3);
                 ctx.beginPath();
                 ctx.moveTo(0, 0);
                 ctx.lineTo(s/2, 0);
                 ctx.arc(0, 0, s/2, 0, Math.PI / 3);
                 ctx.closePath();
                 ctx.fill();
             }
             
             // Center circle
             ctx.beginPath();
             ctx.arc(0, 0, s/6, 0, Math.PI * 2);
             ctx.fill();
             ctx.restore();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    drawSymbol(x, y, spacing * 0.5 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
